import React, {useState, useCallback, useEffect} from 'react';
import {
  DropZone,
  Page,
  Card,
  Stack,
  Button
} from '@shopify/polaris';
import Papa from 'papaparse'
import UploadedFile from './UploadedFile';
import { updateDeliveryEstimate } from '../../services/deliveryEstimate';
import './index.css';

interface CsvResult {
  data: [];
  errors: [],
  meta: any
}

export default function DeliveryEstimate(props: any) {
  const primaryAction = {content: 'Back', url: '/'};

  const [files, setFiles] = useState<File[]>([]);
  //const [csvResultArray, setCsvResultArray] = useState<[]>([]);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const handleDropZoneDrop = (_dropFiles: File[], acceptedFiles: File[], _rejectedFiles: File[]) => {
    const _f = [...files, ...acceptedFiles];
    setFiles(_f);

    if (_f.length > 0 && isButtonDisabled === true) {
      setIsButtonDisabled(false);
    }
  };

  const uploadCSVData = (csvData: any[]) => {
    updateDeliveryEstimate(csvData);
  };

  const handleSubmit = useCallback(() => {
    setIsUpdating(true);

    for(let i = 0; i < files.length; i++) {
      Papa.parse(files[i], {
        header: true,
        complete: (result: CsvResult) => {
          console.log('complete', result);

          const csv_data: any[] = result.data.map((row: any) => {
            const _r: any = {};
            for (const key in row) {
              _r[key.toLowerCase()] = row[key];
            }
            return _r;
          });
          uploadCSVData(csv_data);
        },
        error: (res) => {
          console.log('error', res);
        }
      });
    }
  }, [files]);


  const validFileTypes = ['text/csv'];

  const uploadedFiles = files.length > 0 && (
    <Stack>
      {files.map((file, index) => (
        <UploadedFile key={index} file={file} />
      ))}
    </Stack>
  );

  const fileUpload = !files.length ? <DropZone.FileUpload /> : uploadedFiles ;

  return (
    <Page
    title="Delivery Estimate"
    primaryAction={primaryAction}
  >
    <Card sectioned>
      <DropZone onDrop={handleDropZoneDrop} accept={validFileTypes.join(',')}>
        {/*uploadedFiles*/}
        {fileUpload}
      </DropZone>
    </Card>
    <Card sectioned>
      <Button
        loading={isUpdating}
        disabled={isButtonDisabled}
        onClick={handleSubmit}
        primary>Update</Button>
    </Card>
  </Page>
  );
}
